var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsTwitter = function SvgNewsTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7431 12.2661L3 3.6875H8.34101L12.5035 8.98963L16.9504 3.71137H19.892L13.9257 10.8013L21 19.8125H15.6749L11.1678 14.0786L6.35607 19.7966H3.39858L9.7431 12.2661ZM16.4511 18.2231L6.27493 5.27695H7.56424L17.7276 18.2231H16.4511Z",
    fill: "currentColor"
  })));
};
export default SvgNewsTwitter;